module.exports = __webpack_public_path__ + "static/media/preanestesas-nav.a6ff520c.png";